/**
 * Enum specifying the direction for animations, popovers, or dropdowns.
 */
export enum Direction {
  None = '',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}
